const i18n = {
  baseUrl: 'https://www.bigo.tv',
  strategy: 'prefix_and_default',
  detectBrowserLanguage: {
    alwaysRedirect: true
    // onlyOnNoPrefix: true
  },
  lazy: true,
  langDir: 'langs/',
  defaultLocale: 'en',
  vueI18n: {
    fallbackLocale: 'en'
  },
  locales: [
    { code: 'ar', iso: 'ar', file: 'ar.js', country: 'SA' },
    { code: 'de', iso: 'de', file: 'de.js', country: 'DE' },
    {
      code: 'es',
      iso: 'es',
      file: 'es.js',
      country: 'ES',
      searchCountry: 'ALL'
    },
    {
      code: 'fr',
      iso: 'fr',
      file: 'fr.js',
      country: 'FR',
      searchCountry: 'ALL'
    },
    { code: 'hi', iso: 'hi', file: 'hi.js', country: 'IN' },
    { code: 'id', iso: 'id', file: 'id.js', country: 'ID' },
    { code: 'it', iso: 'it', file: 'it.js', country: 'IT' },
    { code: 'ja', iso: 'ja', file: 'ja.js', country: 'JP' },
    { code: 'ko', iso: 'ko', file: 'ko.js', country: 'KR' },
    {
      code: 'mm',
      iso: 'my',
      file: 'mm.js',
      country: 'MM',
      searchCountry: 'ALL'
    },
    { code: 'ms', iso: 'ms', file: 'ms.js', country: 'MY' },
    {
      code: 'nl',
      iso: 'nl',
      file: 'nl.js',
      country: 'NL',
      searchCountry: 'ALL'
    },
    {
      code: 'pl',
      iso: 'pl',
      file: 'pl.js',
      country: 'US',
      searchCountry: 'ALL'
    },
    {
      code: 'pt',
      iso: 'pt',
      file: 'pt.js',
      country: 'PT',
      searchCountry: 'ALL'
    },
    {
      code: 'ro',
      iso: 'ro',
      file: 'ro.js',
      country: 'RO',
      searchCountry: 'ALL'
    },
    { code: 'ru', iso: 'ru', file: 'ru.js', country: 'RU' },
    {
      code: 'se',
      iso: 'sv',
      file: 'se.js',
      country: 'SE',
      searchCountry: 'ALL'
    },
    { code: 'th', iso: 'th', file: 'th.js', country: 'TH' },
    { code: 'tr', iso: 'tr', file: 'tr.js', country: 'TR' },
    { code: 'vi', iso: 'vi', file: 'vi.js', country: 'VN' },
    { code: 'cn', iso: 'zh', file: 'cn.js', country: 'CN' },
    { code: 'tw', iso: 'zh-TW', file: 'tw.js', country: 'TW' },
    { code: 'en', iso: 'en', file: 'en.js', country: 'US' }
    // { code: 'hk', iso: 'zh-HK', file: 'tw.js' }
    // 理论上ios越详细，<meta property="og:locale:alternate">会越多，SEO越好，但是会让nuxt-i18n产生routename重复的告警，先注释掉了
    // { code: 'ar', iso: 'ar-DZ', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-BH', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-EG', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-IQ', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-JO', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-KW', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-LB', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-LY', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-MA', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-OM', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-QA', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-SA', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-SY', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-TN', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-AE', file: 'ar.js' },
    // { code: 'ar', iso: 'ar-YE', file: 'ar.js' },
    // { code: 'de', iso: 'de-AT', file: 'de.js' },
    // { code: 'de', iso: 'de-DE', file: 'de.js' },
    // { code: 'de', iso: 'de-LI', file: 'de.js' },
    // { code: 'de', iso: 'de-LU', file: 'de.js' },
    // { code: 'de', iso: 'de-CH', file: 'de.js' },
    // { code: 'en', iso: 'en-AU', file: 'en.js' },
    // { code: 'en', iso: 'en-BZ', file: 'en.js' },
    // { code: 'en', iso: 'en-CA', file: 'en.js' },
    // { code: 'en', iso: 'en-CB', file: 'en.js' },
    // { code: 'en', iso: 'en-GB', file: 'en.js' },
    // { code: 'en', iso: 'en-IN', file: 'en.js' },
    // { code: 'en', iso: 'en-IE', file: 'en.js' },
    // { code: 'en', iso: 'en-JM', file: 'en.js' },
    // { code: 'en', iso: 'en-NZ', file: 'en.js' },
    // { code: 'en', iso: 'en-PH', file: 'en.js' },
    // { code: 'en', iso: 'en-ZA', file: 'en.js' },
    // { code: 'en', iso: 'en-TT', file: 'en.js' },
    // { code: 'en', iso: 'en-US', file: 'en.js' },
    // { code: 'es', iso: 'es-AR', file: 'es.js' },
    // { code: 'es', iso: 'es-BO', file: 'es.js' },
    // { code: 'es', iso: 'es-CL', file: 'es.js' },
    // { code: 'es', iso: 'es-CO', file: 'es.js' },
    // { code: 'es', iso: 'es-CR', file: 'es.js' },
    // { code: 'es', iso: 'es-DO', file: 'es.js' },
    // { code: 'es', iso: 'es-EC', file: 'es.js' },
    // { code: 'es', iso: 'es-SV', file: 'es.js' },
    // { code: 'es', iso: 'es-GT', file: 'es.js' },
    // { code: 'es', iso: 'es-HN', file: 'es.js' },
    // { code: 'es', iso: 'es-MX', file: 'es.js' },
    // { code: 'es', iso: 'es-NI', file: 'es.js' },
    // { code: 'es', iso: 'es-PA', file: 'es.js' },
    // { code: 'es', iso: 'es-PY', file: 'es.js' },
    // { code: 'es', iso: 'es-PE', file: 'es.js' },
    // { code: 'es', iso: 'es-PR', file: 'es.js' },
    // { code: 'es', iso: 'es-ES', file: 'es.js' },
    // { code: 'es', iso: 'es-UY', file: 'es.js' },
    // { code: 'es', iso: 'es-VE', file: 'es.js' },
    // { code: 'fr', iso: 'fr-CA', file: 'fr.js' },
    // { code: 'fr', iso: 'fr-FR', file: 'fr.js' },
    // { code: 'fr', iso: 'fr-LU', file: 'fr.js' },
    // { code: 'fr', iso: 'fr-BE', file: 'fr.js' },
    // { code: 'fr', iso: 'fr-CH', file: 'fr.js' },
    // { code: 'it', iso: 'it-IT', file: 'it.js' },
    // { code: 'it', iso: 'it-CH', file: 'it.js' },
    // { code: 'ms', iso: 'ms-BN', file: 'ms.js' },
    // { code: 'ms', iso: 'ms-MY', file: 'ms.js' },
    // { code: 'nl', iso: 'nl-BE', file: 'nl.js' },
    // { code: 'nl', iso: 'nl-NL', file: 'nl.js' },
    // { code: 'pt', iso: 'pt-BR', file: 'pt.js' },
    // { code: 'pt', iso: 'pt-PT', file: 'pt.js' },
    // { code: 'ro', iso: 'ro-MO', file: 'ro.js' },
    // { code: 'ru', iso: 'ru-MO', file: 'ru.js' },
    // { code: 'se', iso: 'sv-FI', file: 'se.js' },
    // { code: 'se', iso: 'sv-SE', file: 'se.js' },
    // { code: 'cn', iso: 'zh-CN', file: 'cn.js' },
    // { code: 'tw', iso: 'zh-SG', file: 'tw.js' },
    // { code: 'hk', iso: 'zh-MO', file: 'tw.js' }
  ]
};

export default i18n;
